export enum otherConsts {
  OR = 'OR',
  AND = 'AND',
}
